import React, { FC } from "react";
import dayjs from "dayjs";
import styled from "styled-components";

import { Icon } from "@components/Icon";
import { FilterHeader, FilterHeaderType } from "./FilterHeader";
import { MonthPicker } from "./MonthPicker";

interface DateRange {
  date_before?: string;
  date_after?: string;
}

export interface DatesFilterType extends Omit<FilterHeaderType, "onChange"> {
  onChange: (data: DateRange) => void;
  checkedOptions: DateRange;
}

const Filter = styled.div`
  display: inline;
`;

const toServerDate = (date: Date | null | undefined) => {
  if (!date) return undefined;

  return dayjs(date).format("YYYY-MM-DD");
};

export const DatesFilterHeader: FC<DatesFilterType> = ({
  checkedOptions,
  onChange,
  ...props
}) => {
  const filterIsNotApplied =
    !checkedOptions.date_before && !checkedOptions.date_after;

  return (
    <FilterHeader
      {...props}
      customFilter={
        <Filter onClick={(e) => e.stopPropagation()}>
          <MonthPicker
            isClearing
            showDates
            trigger={
              <Icon.Filter
                title="Filter column"
                applied={!filterIsNotApplied}
              />
            }
            initialFrom={
              checkedOptions.date_after
                ? new Date(checkedOptions.date_after)
                : null
            }
            initialTo={
              checkedOptions.date_before
                ? new Date(checkedOptions.date_before)
                : null
            }
            setMonths={(from, to) =>
              onChange({
                date_before: toServerDate(to),
                date_after: toServerDate(from),
              })
            }
          />
        </Filter>
      }
    />
  );
};

export default DatesFilterHeader;
